import { IsNumber, IsString, Max, MaxLength, Min, MinLength } from 'class-validator';

/**
 * Body for `POST /iot/sensors/:sensorId/verifications` — the semestral
 * "confronta col termometro" spot-check. The operator supplies only the
 * thermometer reading and what instrument it came from; the probe reading,
 * deviation, tolerance and outcome are all computed server-side against the
 * sensor's current `lastTemperature` (see IotSensorVerificationService).
 */
export class CreateIotSensorVerificationDto {
  /** Reading from the operator's own calibrated thermometer, in °C. */
  @IsNumber()
  @Min(-40)
  @Max(100)
  referenceTemperature!: number;

  /** Free-text identifying the thermometer used (e.g. "Termometro tarato cucina"). */
  @IsString()
  @MinLength(2)
  @MaxLength(200)
  referenceInstrument!: string;
}
